const granviroReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!granviroReducedMotion && 'IntersectionObserver' in window) {
  const granviroSections = document.querySelectorAll('main .shopify-section');
  const granviroObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      granviroObserver.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });

  granviroSections.forEach((section) => {
    section.classList.add('granviro-reveal');
    granviroObserver.observe(section);
  });
}

